import {
  PaginasMenuAttributes,
  UpdatePaginasMenu,
} from "@fl/shared/src/types/models/suporte_fl/paginas_menus";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { SubmitHandler, useForm } from "react-hook-form";
import { menusSchema } from "../../../../schemas/menus";

interface IProps {
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  menu: UpdatePaginasMenu | undefined;
  setMenu: React.Dispatch<React.SetStateAction<UpdatePaginasMenu | undefined>>;
  onUpdate: (menu: UpdatePaginasMenu) => void;
}

export type MenuFormInputs = Omit<
  PaginasMenuAttributes,
  "id_pagina_menu" | "createdAt" | "updatedAt"
>;

const ModalMenu: React.FC<IProps> = ({
  showModal,
  setShowModal,
  menu,
  setMenu,
  onUpdate,
}) => {
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    clearErrors,
    formState: { errors },
    reset,
  } = useForm<MenuFormInputs>({
    resolver: yupResolver(menusSchema),
  });

  useEffect(() => {
    if (menu) {
      clearErrors();
      setValue("pagina", menu.pagina);
      setValue("link", menu.link);
      setValue("config", menu.config);
      setValue("divisor", menu.divisor);
      setValue("ordem", menu.ordem);
    }
  }, [menu]);

  const onSubmit: SubmitHandler<MenuFormInputs> = async (data) => {
    if (menu) {
      var updated_menu: UpdatePaginasMenu = { ...menu, ...data };
      onUpdate(updated_menu);
    }
  };

  const handleReset = () => {
    reset({ ...menu });
  };

  const [forceUpdateTrigger, setForceUpdateTrigger] = useState(false);
  const forceUpdate = () => {
    setForceUpdateTrigger((prev) => !prev);
  };

  return (
    <Modal
      show={showModal}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={() => {
        setMenu(undefined);
        setShowModal(false);
      }}
    >
      {menu && (
        <>
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              {menu.new ? "Novo Menu" : `Alterar Menu [${menu.pagina}]`}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Form onSubmit={handleSubmit(onSubmit)} noValidate>
              <Row className="mt-2">
                <Col className="mt-1">
                  <Form.Group controlId="formNPagina">
                    <Form.Label>Nome da Página:</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Digite o nome da página"
                      {...register("pagina")}
                      isInvalid={!!errors.pagina}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.pagina?.message}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col className="mt-1">
                  <Form.Group controlId="formLink">
                    <Form.Label>Link da Página:</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Digite o link da página"
                      {...register("link")}
                      isInvalid={!!errors.link}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.link?.message}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mt-3">
                <Col className="mt-1">
                  <Form.Group controlId="formOrdem">
                    <Form.Label>Ordem do Menu:</Form.Label>
                    <Form.Control
                      type="number"
                      placeholder="Digite a ordem"
                      {...register("ordem")}
                      isInvalid={!!errors.ordem}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.ordem?.message}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col className="mt-1">
                  <Form.Group controlId="formDivisor">
                    <Form.Label>Divisor?</Form.Label>
                    <Form.Check
                      type="checkbox"
                      label={getValues("divisor") ? "Sim" : "Não"}
                      {...register("divisor", {
                        onChange: () => forceUpdate(), // Uma função para forçar a re-renderização
                      })}
                      isInvalid={!!errors.divisor}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.divisor?.message}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col className="mt-1">
                  <Form.Group controlId="formconfig">
                    <Form.Label>Configurações?</Form.Label>
                    <Form.Check
                      type="checkbox"
                      label={getValues("config") ? "Sim" : "Não"}
                      {...register("config", {
                        onChange: () => forceUpdate(), // Uma função para forçar a re-renderização
                      })}
                      isInvalid={!!errors.config}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.config?.message}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Modal.Body>

          <Modal.Footer>
            <div
              style={{ width: "100%" }}
              className="d-flex justify-content-between"
            >
              <Button
                variant="outline-danger"
                type="submit"
                onClick={handleReset}
              >
                Limpar Dados
              </Button>
              <Button
                variant="outline-success"
                type="submit"
                onClick={handleSubmit(onSubmit)}
              >
                {menu.new ? "Cadastrar Menu" : "Alterar Menu"}
              </Button>
            </div>
          </Modal.Footer>
        </>
      )}
    </Modal>
  );
};

export default ModalMenu;
